<template>
  <v-container id="create" fluid>
    <v-row>
      <v-col cols="3">
        <ClubController/>
      </v-col>
      <v-col cols="9">
        <!-- League Selector (hidden temporarily - under development) -->
        <!-- <div v-if="isAdminOrFounder" class="league-header">
          <LeagueSelector v-model="selectedLeague" @change="onLeagueChange"/>
        </div> -->
        <ClubMenu/>
        <RouterView/>
      </v-col>
    </v-row>

    <!-- Button for new trade - hidden, actions moved to individual views !-->
    <v-speed-dial style="z-index: 10;" v-if="false"
                  v-model="actionActivator" open-on-hover direction="top" fixed bottom right class="mr-7 mb-7">
      <template v-slot:activator>
        <v-btn :color="`#${$store.state.clubMember.club.primaryColor} !important`" fab>
          <v-icon v-if="actionActivator" color="#FFFFFF">fa-times</v-icon>
          <v-icon color="#FFFFFF !important" v-else>fa-plus</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark :color="`#${$store.state.clubMember.club.primaryColor} !important`" @click="addTournament"><v-icon color="#FFFFFF !important">fa-trophy</v-icon></v-btn>
      <v-btn fab dark :color="`#${$store.state.clubMember.club.primaryColor} !important`" @click="addChannel"><v-icon color="#FFFFFF !important">fa-layer-group</v-icon></v-btn>
      <v-btn fab dark :color="`#${$store.state.clubMember.club.primaryColor} !important`" @click="overlayAddEvent = true"><v-icon color="#FFFFFF !important">fa-calendar-alt</v-icon></v-btn>
      <v-btn fab dark :color="`#${$store.state.clubMember.club.primaryColor} !important`" @click="overlayAddPost = true"><v-icon color="#FFFFFF !important">fa-sticky-note</v-icon></v-btn>
    </v-speed-dial>

    <!-- Overlay for add post !-->
    <v-overlay :dark="false" :value="overlayAddPost">
      <AddPost @closeWindow="overlayAddPost = false"/>
    </v-overlay>
    <!-- Overlay for add event !-->
    <v-overlay :dark="false" :value="overlayAddEvent">
      <AddEvent @closeWindow="overlayAddEvent = false"/>
    </v-overlay>
    <!-- Overlay for add channel !-->
    <v-overlay :dark="false" :value="overlayAddChannel">
      <AddChannel :arePublicChannelsUnavailable="arePublicChannelsUnavailable" :arePrivateChannelsUnavailable="arePrivateChannelsUnavailable"
        @closeWindow="overlayAddChannel = false"/>
    </v-overlay>
    <!-- Overlay for add tournament !-->
    <v-overlay :dark="false" :value="overlayAddTournament">
      <AddTournament :featurePermissionInfo="tournamentPermissionInfo" @closeWindow="overlayAddTournament = false"/>
    </v-overlay>

    <v-overlay :dark="false" v-model="overlayUnavailableFeature">
      <UnavailableFeature :hasCloseWindowAction="true" @closeWindow="overlayUnavailableFeature = false"/>
    </v-overlay>

    <!-- Side Quests Drawer (hidden temporarily - under development) -->
    <!-- <SideQuestsDrawer v-if="isAdminOrFounder" v-model="showLeagueDrawer" :quests="leagueQuests" :primaryColor="clubPrimaryColor"/> -->
  </v-container>
</template>

<script>
import ClubController from "@/views/Community/components/ClubController";
import ClubMenu from "@/views/Community/components/ClubMenu";
import LeagueSelector from "@/views/Community/components/LeagueSelector";
import AddPost from "@/views/Community/components/AddPost";
import AddEvent from "@/views/Community/components/AddEvent";
import AddTournament from "@/views/Community/components/AddTournament";
import AddChannel from "@/views/Community/components/AddChannel";
import UnavailableFeature from './../components/UnavailableFeature';
import SideQuestsDrawer from '@/views/Tournament/components/SideQuestsDrawer';
import TournamentRepository from '../../../repositories/tournament';
import ClubRepository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "ClubIndex",
  components: {AddChannel, AddTournament, AddEvent, AddPost, ClubMenu, ClubController, UnavailableFeature, LeagueSelector, SideQuestsDrawer},
  mounted() {
    this.init();
  },
  computed: {
    clubPrimaryColor() {
      return this.$store.state.clubMember?.club?.primaryColor || 'EF4444';
    },
    isAdminOrFounder() {
      const rol = this.$store.state.clubMember?.rol;
      return rol === 'FOUNDER' || rol === 'ADMIN';
    }
  },
  data() {
    return {
      arePublicChannelsUnavailable: true,
      arePrivateChannelsUnavailable: true,
      isTournamentCreationUnavailable: true,
      tournamentPermissionInfo: null,
      actionActivator: false,
      overlayAddPost: false,
      overlayAddTournament: false,
      overlayAddEvent: false,
      overlayAddChannel: false,
      overlayUnavailableFeature: false,
      selectedLeague: 'bronze',
      showLeagueDrawer: false,
      leagueQuests: [],
      loadingQuests: false,
    };
  },
  methods: {
    ...mapMutations(['setClubTournaments', 'setClubPermissions']),
    async init() {
      // Verifying if refreshing
      if (this.$store.state.clubMember === undefined || this.$store.state.clubMember === null)
        this.$router.push('/community');
      await ClubRepository.getClubPermissions(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubPermissions(response.data);
      });
      await TournamentRepository.getTournamentsByClubId(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubTournaments(response.data);
      });
      this.validateFeaturesAvailable();
    },
    validateFeaturesAvailable() {
      let permissions = this.$store.state.clubPermissions;
      for(let permission of permissions) {
        if(permission.clubFeature.name == 'PUBLIC_CHANNELS') {
          this.arePublicChannelsUnavailable = false;
        } else if (permission.clubFeature.name == 'PRIVATE_CHANNELS') {
          this.arePrivateChannelsUnavailable = false;
        } else if (permission.clubFeature.name == 'TOURNAMENT_CREATION') {
          this.isTournamentCreationUnavailable = false;
          this.tournamentPermissionInfo = permission;
        }
      }
    },
    addChannel() {
      if(this.arePublicChannelsUnavailable && this.arePrivateChannelsUnavailable) {
        this.overlayUnavailableFeature = true;
      } else {
        this.overlayAddChannel = true;
      }
    },
    addTournament() {
      if (this.isTournamentCreationUnavailable) {
        this.overlayUnavailableFeature = true;
      } else {
        this.overlayAddTournament = true;
      }
    },
    onLeagueChange(leagueId) {
      this.$emit('league-change', leagueId);
      this.fetchQuestsByLeague(leagueId);
      this.showLeagueDrawer = true;
    },
    async fetchQuestsByLeague(leagueId) {
      const leaderboardTypeMap = {
        bronze: 'BRONZE',
        silver: 'SILVER',
        gold: 'GOLD'
      };
      const leaderboardType = leaderboardTypeMap[leagueId];
      if (!leaderboardType) return;

      this.loadingQuests = true;
      try {
        const clubId = this.$store.state.clubMember.club.id;
        const response = await ClubRepository.getQuestsByClubAndLeague(clubId, leaderboardType);
        if (response.status < 400) {
          this.leagueQuests = this.transformQuestsResponse(response.data);
        }
      } catch (error) {
        console.error('Error fetching quests:', error);
        this.leagueQuests = [];
      } finally {
        this.loadingQuests = false;
      }
    },
    transformQuestsResponse(data) {
      const transformQuest = (quest, period) => ({
        id: quest.questId,
        period: period,
        status: quest.completed ? 'completed' : 'active',
        bullets: quest.targetValue,
        completedBullets: quest.currentProgress,
        title: quest.name,
        subtitle: quest.description,
        reward: `+${quest.rewardPoints} pts`,
      });

      const quests = [];

      if (data.dailyQuests) {
        data.dailyQuests.forEach(quest => {
          quests.push(transformQuest(quest, 'daily'));
        });
      }

      if (data.weeklyQuests) {
        data.weeklyQuests.forEach(quest => {
          quests.push(transformQuest(quest, 'weekly'));
        });
      }

      if (data.oneTimeQuests) {
        data.oneTimeQuests.forEach(quest => {
          quests.push(transformQuest(quest, 'weekly'));
        });
      }

      return quests;
    }
  }
}
</script>

<style scoped lang="scss">
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }

  .league-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
  }
</style>
